// @flow
import React, { PureComponent, Fragment } from 'react';
import type { MatchType, ParticipantType } from 'types/Competition';
import CompetitionResultRanking from 'containers/competition/CompetitionResultRankingContainer';
import { getDateFromString, getMonthName } from 'utils/dateUtils';

export type StateProps = {
  slug: string,
  participants: Array<ParticipantType>,
  prevDay: {
    poules: Array<{
      pouleId: number,
      rencontres: Array<MatchType>,
    }>,
    journee_id: string,
    nombre_rencontres: number,
    journee_date: string,
    journee_nom: string,
    phase_id: string,
    phase_nom: string
  },
  nextDay: {
    poules: Array<{
      pouleId: number,
      rencontres: Array<MatchType>,
    }>,
    journee_id: boolean,
    nombre_rencontres: number,
    journee_date: string,
    journee_nom: string,
  }
};

type Props = {
  pouleId: number
} & StateProps;

class CompetitionResultPool extends PureComponent<Props> {
  renderScore = (locaux_score: string, visiteurs_score: string, winnerHome: boolean) => {
    if (!locaux_score || !visiteurs_score) {
      return <span className="match__colon">VS</span>;
    }
    return (
      <Fragment>
        <span className={winnerHome ? "ft-700" : ""}>{locaux_score}</span>
        <span className="match__colon">:</span>
        <span className={!winnerHome ? "ft-700" : ""}>{visiteurs_score}</span>
      </Fragment>
    );
  }

  renderRowMatch = (matchDay: Array<MatchType>): any => {
    const { participants } = this.props;

    return matchDay.map((match, index) => {
      const dom = participants.filter(participant => participant.nom === match.locaux);
      const ext = participants.filter(participant => participant.nom === match.visiteurs);
      let domLogo = '/img/logo/placeholder-club.png';
      let extLogo = '/img/logo/placeholder-club.png';
      if (dom.length > 0) {
        if (dom[0].embleme) {
          domLogo = dom[0].embleme;
        }
      }
      if (ext.length > 0) {
        if (ext[0].embleme) {
          extLogo = ext[0].embleme;
        }
      }

      return (
        <li key={index}>
          <a
            className="match match--score box box--smoke"
            title="Voir les informations du match TEAM-TEAM"
            href={`https://competitions.ffr.fr/competitions/${this.props.slug}/match-${match.id_ovale}.html`}
            target="_blank"
            rel="noopener noreferrer">
            <div className="match__club">
              <p className={parseInt(match.locaux_score, 10) > parseInt(match.visiteurs_score, 10) ? "ft-700" : ""}>
                {match.locaux}
                <img src={domLogo} alt="" width="24" height="24"/>
              </p>
            </div>
            <div className="match__info">
              <p className="match__score">
                {this.renderScore(
                  match.locaux_score,
                  match.visiteurs_score,
                  parseInt(match.locaux_score, 10) > parseInt(match.visiteurs_score, 10))}
              </p>
            </div>
            <div className="match__club">
              <p className={parseInt(match.visiteurs_score, 10) > parseInt(match.locaux_score, 10) ? "ft-700" : ""}>
                <img src={extLogo} alt="" width="24" height="24"/>
                {match.visiteurs}
              </p>
            </div>
          </a>
        </li>
      );
    });
  }

  renderTabPrevMatch = () => {
    const { prevDay, slug } = this.props;
    const formatedDate = getDateFromString(prevDay.journee_date);
    let prevDayFiltered;

    if (this.props.pouleId && parseInt(this.props.pouleId, 10) !== 0) {
      prevDayFiltered = prevDay.poules.filter(poule => poule.pouleId === this.props.pouleId);
    } else {
      prevDayFiltered = prevDay.poules;
    }

    if (!prevDay.journee_nom || 
        !prevDay.journee_date || 
        !prevDay.nombre_rencontres || 
        !prevDayFiltered[0] || 
        !prevDayFiltered[0].rencontres) {
      return(
        <div className="block-competition mb-6 mb-md-7">
          <h3 className="mb-3">Résultats</h3>
          <span>Pas de précédente journée pour les équipes de la ligue</span>
          {slug &&
            <a href={`https://competitions.ffr.fr/competitions/${slug}/calendrier.html`} className="link-chevron link-chevron--blue link-chevron--inline" data-label="" target="blank" rel="noopener noreferrer">
              <span>Voir le calendrier des rencontres</span>
              <i className="icon icon-external"></i>
            </a>
          }
        </div>
      );
    }

    const numberOfMatchOnPrevDay = prevDayFiltered[0].rencontres.length;

    return (
      <div className="block-competition mb-6 mb-md-7">
        <h3 className="mb-3">Résultats</h3>
        <p className="block-competition__head ft-500 mb-2">
          {`${prevDay.journee_nom}  — `}
          <span>
            {`${formatedDate.getDate()} ${getMonthName(formatedDate.getMonth())} ${formatedDate.getFullYear()}`}
          </span>
          <span className="block-competition__counter">{numberOfMatchOnPrevDay} rencontre{numberOfMatchOnPrevDay > 1 ? 's' : ''}</span>
        </p>
        <ul className="list-match">
          {this.renderRowMatch(prevDayFiltered[0].rencontres)}
        </ul>
        {slug &&
          <a href={`https://competitions.ffr.fr/competitions/${slug}/calendrier.html`} className="link-chevron link-chevron--blue link-chevron--inline" data-label="" target="blank" rel="noopener noreferrer">
            <span>Voir le calendrier des rencontres</span>
            <i className="icon icon-external"></i>
          </a>
        }
      </div>
    );
  }

  renderTabNextMatch = () => {
    const { nextDay, slug } = this.props;
    let nextDayFiltered;

    if (this.props.pouleId && parseInt(this.props.pouleId, 10) !== 0) {
      nextDayFiltered = nextDay.poules.filter(poule => poule.pouleId === this.props.pouleId);
    } else {
      nextDayFiltered = nextDay.poules;
    }

    const nextDayDate = nextDay.journee_date ? getDateFromString(nextDay.journee_date) : new Date();

    if (!nextDay ||
        !nextDay.journee_nom || 
        !nextDay.journee_date || 
        !nextDay.nombre_rencontres || 
        !nextDayFiltered[0] || 
        !nextDayFiltered[0].rencontres) {
      return(
        <div className="block-competition mb-6 mb-md-7">
          <h3 className="mb-3">Prochaines rencontres</h3>
          {nextDay.journee_nom && nextDay.journee_date && 
          <p className="block-competition__head ft-500 mb-2">
            {`${nextDay.journee_nom}  — `}
            <span>{`${nextDayDate.getDate()} ${getMonthName(nextDayDate.getMonth())} ${nextDayDate.getFullYear()}`}</span>
          </p>}
          <span>{!nextDay ? `Pas de prochaine journée pour les équipes de la ligue` : `Pas de rencontres disponibles pour la prochaine journée`} </span>
          {slug &&
            <a href={`https://competitions.ffr.fr/competitions/${slug}/calendrier.html`} className="link-chevron link-chevron--blue link-chevron--inline" data-label="" target="blank" rel="noopener noreferrer">
              <span>Voir le calendrier des rencontres</span>
              <i className="icon icon-external"></i>
            </a>
          }
        </div>
      );
    }

    
    const numberOfMatchOnNextDay = nextDayFiltered[0].rencontres.length;

    return (
      <div className="block-competition mb-6 mb-md-7">
        <h3 className="mb-3">Prochaines rencontres</h3>
        <p className="block-competition__head ft-500 mb-2">
          {`${nextDay.journee_nom}  — `}
          <span>{`${nextDayDate.getDate()} ${getMonthName(nextDayDate.getMonth())} ${nextDayDate.getFullYear()}`}</span>
          <span className="block-competition__counter">{numberOfMatchOnNextDay} rencontre{numberOfMatchOnNextDay > 1 ? 's' : ''}</span>
        </p>
        <ul className="list-match">
          {this.renderRowMatch(nextDayFiltered[0].rencontres)}
        </ul>
        {slug &&
          <a href={`https://competitions.ffr.fr/competitions/${slug}/calendrier.html`} className="link-chevron link-chevron--blue link-chevron--inline" data-label="" target="blank" rel="noopener noreferrer">
            <span>Voir le calendrier des rencontres</span>
            <i className="icon icon-external"></i>
          </a>
        }
      </div>
    );
  }

  render() {
    const { participants } = this.props;

    // si la compétition ne retourne pas de données -> placeholder
    if (participants && !participants.length) {
      return (
        <div className="placeholder">
          <p>
            <i className="icon icon-ball"></i>
            <br />
            <strong className="ft-h5">Compétition en cours de mise à jour</strong>
            <br />
            {`Il n'y a actuellement pas de données disponibles pour cette compétition, merci pour votre compréhension et à bientôt pour découvrir les derniers résultats, les prochaines rencontres et le classement.`}
          </p>
        </div>
      );
    }

    // compétition avec données
    return (
      <div className="row">
        <div className="col col-lg-8on9">
          {this.renderTabPrevMatch()}
          {this.renderTabNextMatch()}
          <CompetitionResultRanking pouleId={this.props.pouleId} />
        </div>
      </div>
    );
  }
}

export default CompetitionResultPool;
